import styled from 'styled-components';
import { ButtonProps, PrimaryButton, SecondaryButton } from 'ui/button';
import { useTranslation } from '../../hooks';
import { useFooterHandlers } from './hooks/useFooterHandlers';
import { useCatInSegQueryBuilderV2FeatureFlag } from './hooks/useCatInSegQueryBuilderV2FeatureFlag';
import { SubmitType } from './types';
import { FORM_ID } from './constants';
import { useCatalogPreviewContext } from './contexts/CatalogPreviewContext';
import { useCatalogSelectionContext } from './contexts/CatalogSelectionContext';
import { useValidateCatalogSelectors } from './hooks/useValidateCatalogSelectors';

const FooterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: ${({ theme }) => theme.spacing.values.half};
`;

export const DATA_TEST = {
  footer: 'catalog-segmentation-footer',
  footerWithFF: 'catalog-segmentation-footer-with-FF',
};

export const Footer = () => {
  const { t } = useTranslation();
  const isFeatureFlagged = useCatInSegQueryBuilderV2FeatureFlag();
  const { isLoading } = useCatalogPreviewContext();
  const { onPreviewOpen, onApplyQuery } = useFooterHandlers();
  const { isEnabled } = useCatalogSelectionContext();
  const validateCatalogSelectors = useValidateCatalogSelectors();

  const getButtonProps = (submitType: SubmitType): ButtonProps =>
    !isEnabled
      ? {
          onClick: validateCatalogSelectors,
          type: 'button',
        }
      : {
          id: submitType,
          form: FORM_ID,
          type: 'submit',
          isDisabled: isLoading,
        };

  return !isFeatureFlagged ? (
    <FooterWrapper data-test={DATA_TEST.footer}>
      <SecondaryButton onClick={onPreviewOpen}>{t('catalogQuery.footer.preview')}</SecondaryButton>
      <PrimaryButton onClick={onApplyQuery}>{t('catalogQuery.footer.query')}</PrimaryButton>
    </FooterWrapper>
  ) : (
    <FooterWrapper data-test={DATA_TEST.footerWithFF}>
      <SecondaryButton {...getButtonProps(SubmitType.preview)}>
        {t('catalogQuery.footer.preview')}
      </SecondaryButton>
      <PrimaryButton {...getButtonProps(SubmitType.apply)}>
        {t('catalogQuery.footer.query')}
      </PrimaryButton>
    </FooterWrapper>
  );
};
